import assignBox from './assignBox';
import history from './history';
import kpi from './kpi';
import dataExport from './dataExport';
import dataUpload from './dataUpload';
import vehicleMarkerPopup from './vehicleMarkerPopup';
import mapLayers from './mapLayers';
import dualList from './dualList';
import changeViewDropdown from './changeViewDropdown';

const index = {
  assignBox,
  history,
  kpi,
  dataExport,
  dataUpload,
  vehicleMarkerPopup,
  mapLayers,
  dualList,
  changeViewDropdown,
};

export default index;
